import React from 'react';
import classNames from 'classnames';

import css from './IconTv.module.css';

/**
 * IconTv icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconTv = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
<svg className={classes}
    width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.5 6H4.5V15H19.5V6Z" fill="#262338"/>
<path fillRule="evenodd" clipRule="evenodd" d="M3.375 3C2.339 3 1.5 3.84 1.5 4.875V16.125C1.5 17.16 2.34 18 3.375 18H9.75V19.5H6C5.80109 19.5 5.61032 19.579 5.46967 19.7197C5.32902 19.8603 5.25 20.0511 5.25 20.25C5.25 20.4489 5.32902 20.6397 5.46967 20.7803C5.61032 20.921 5.80109 21 6 21H18C18.1989 21 18.3897 20.921 18.5303 20.7803C18.671 20.6397 18.75 20.4489 18.75 20.25C18.75 20.0511 18.671 19.8603 18.5303 19.7197C18.3897 19.579 18.1989 19.5 18 19.5H14.25V18H20.625C21.66 18 22.5 17.16 22.5 16.125V4.875C22.5 3.839 21.66 3 20.625 3H3.375ZM3.375 16.5H20.625C20.7245 16.5 20.8198 16.4605 20.8902 16.3902C20.9605 16.3198 21 16.2245 21 16.125V4.875C21 4.77554 20.9605 4.68016 20.8902 4.60984C20.8198 4.53951 20.7245 4.5 20.625 4.5H3.375C3.27554 4.5 3.18016 4.53951 3.10984 4.60984C3.03951 4.68016 3 4.77554 3 4.875V16.125C3 16.332 3.168 16.5 3.375 16.5Z" fill="#262338"/>
</svg>

  );
};

export default IconTv;
